const daysOrders = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
}

export const sortDays = (days) => {
  const arrayOfDays = Object.entries(days)

  const sortedDays = arrayOfDays.sort((a, b) => {
    return daysOrders[a[0]] - daysOrders[b[0]]
  })

  return (
    sortedDays.reduce((res, [currDay, currData]) => {
      return { ...res, [currDay]: currData }
    }, {}) ?? {}
  )
}
